import React from 'react';
import { useIntl } from 'react-intl';

import { required } from '../../util/validators';
import getCountryCodes, { getDeliverableCountryCodes } from '../../translations/countryCodes';
import { FieldTextInput, FieldSelect } from '../../components';

import css from './ProfileAddress.module.css';

const Address = props => {
  const intl = useIntl();
  const t = intl.formatMessage;

  const { fieldId } = props;


  return (
    <div className={css.profileAddress}>
      <FieldTextInput
        className={css.field}
        type="hidden"
        id={`${fieldId}.id`}
        name={`${fieldId}.id`}
        readOnly
      />
      <FieldTextInput
        className={css.field}
        type="text"
        id={`${fieldId}.name`}
        name={`${fieldId}.name`}
        label={t({
          id: 'ProfileAddress.nameLabel',
        })}
        placeholder={t({
          id: 'ProfileAddress.namePlaceholder',
        })}
        validate={required(
          t({
            id: 'ProfileAddress.nameRequired',
          })
        )}
        customErrorClass={css.fieldError}
      />
      <FieldTextInput
        className={css.field}
        type="text"
        id={`${fieldId}.companyName`}
        name={`${fieldId}.companyName`}
        label={t({
          id: 'ProfileAddress.companyNameLabel',
        })}
        placeholder={t({
          id: 'ProfileAddress.companyNamePlaceholder',
        })}
        validate={required(
          t({
            id: 'ProfileAddress.companyNameRequired',
          })
        )}
        customErrorClass={css.fieldError}
      />
      <div className={css.addressStreetContainer}>
        <FieldTextInput
          className={css.addressStreet}
          type="text"
          id={`${fieldId}.street`}
          name={`${fieldId}.street`}
          label={t({
            id: 'ProfileAddress.streetLabel',
          })}
          placeholder={t({
            id: 'ProfileAddress.streetPlaceholder',
          })}
          validate={required(
            t({
              id: 'ProfileAddress.streetRequired',
            })
          )}
        customErrorClass={css.fieldError}
        />
        <FieldTextInput
          className={css.addressStreetNumber}
          type="text"
          id={`${fieldId}.streetNumber`}
          name={`${fieldId}.streetNumber`}
          label={t({
            id: 'ProfileAddress.streetNumberLabel',
          })}
          placeholder={t({
            id: 'ProfileAddress.streetNumberPlaceholder',
          })}
          validate={required(
            t({
              id: 'ProfileAddress.streetNumberRequired',
            })
          )}
        customErrorClass={css.fieldError}
        />
      </div>
      <div className={css.addressPostalcodeContainer}>
        <FieldTextInput
          className={css.addressPostalcode}
          type="text"
          id={`${fieldId}.postalcode`}
          name={`${fieldId}.postalcode`}
          label={t({
            id: 'ProfileAddress.postalcodeLabel',
          })}
          placeholder={t({
            id: 'ProfileAddress.postalcodePlaceholder',
          })}
          validate={required(
            t({
              id: 'ProfileAddress.postalcodeRequired',
            })
          )}
        customErrorClass={css.fieldError}
        />
        <FieldTextInput
          className={css.addressCity}
          type="text"
          id={`${fieldId}.city`}
          name={`${fieldId}.city`}
          label={t({
            id: 'ProfileAddress.cityLabel',
          })}
          placeholder={t({
            id: 'ProfileAddress.cityPlaceholder',
          })}
          validate={required(
            t({
              id: 'ProfileAddress.cityRequired',
            })
          )}
        customErrorClass={css.fieldError}
        />
      </div>
      <FieldSelect
        className={css.field}
        id={`${fieldId}.country`}
        name={`${fieldId}.country`}
        label={t({
          id: 'ProfileAddress.countryLabel',
        })}
        placeholder={t({
          id: 'ProfileAddress.countryPlaceholder',
        })}
        validate={required(
          t({
            id: 'ProfileAddress.countryRequired',
          })
        )}
        customErrorClass={css.fieldError}
      >
        <option value="" disabled>
          {t({ id: 'ProfileAddress.countryPlaceholder' })}
        </option>
        {getDeliverableCountryCodes(intl.locale).map(item => (
          <option key={item.code} value={item.code}>
            {item.name}
          </option>
        ))}
      </FieldSelect>
      <div className={css.addressCompanyContainer}>
        <FieldTextInput
          className={css.personOnSite}
          type="text"
          id={`${fieldId}.contactPersonOnSite`}
          name={`${fieldId}.contactPersonOnSite`}
          label={t({
            id: 'ProfileAddress.contactPersonOnSiteLabel',
          })}
          placeholder={t({
            id: 'ProfileAddress.contactPersonOnSitePlaceholder',
          })}
          validate={required(
            t({
              id: 'ProfileAddress.contactPersonOnSiteRequired',
            })
          )}
        customErrorClass={css.fieldError}
        />
        <FieldTextInput
          className={css.personPhoneNo}
          type="text"
          id={`${fieldId}.contactPhoneOnSite`}
          name={`${fieldId}.contactPhoneOnSite`}
          label={t({
            id: 'ProfileAddress.contactPhoneOnSiteLabel',
          })}
          placeholder={t({
            id: 'ProfileAddress.contactPhoneOnSitePlaceholder',
          })}
          validate={required(
            t({
              id: 'ProfileAddress.contactPhoneOnSiteRequired',
            })
          )}
        customErrorClass={css.fieldError}
        />
      </div>
      <FieldTextInput
        className={css.field}
        type="text"
        id={`${fieldId}.gpsCoordinates`}
        name={`${fieldId}.gpsCoordinates`}
        label={t({
          id: 'ProfileAddress.gpsCoordinatesLabel',
        })}
        placeholder={t({
          id: 'ProfileAddress.gpsCoordinatesPlaceholder',
        })}
        customErrorClass={css.fieldError}
      />

      <FieldTextInput
        className={css.field}
        type="textarea"
        id={`${fieldId}.additionalInfo`}
        name={`${fieldId}.additionalInfo`}
        label={t({
          id: 'ProfileAddress.additionalInfoLabel',
        })}
        placeholder={t({
          id: 'ProfileAddress.additionalInfoPlaceholder',
        })}
        // validate={required(
        //   t({
        //     id: 'ProfileAddress.additionalInfoRequired',
        //   })
        // )}
        customErrorClass={css.fieldError}
      />
    </div>
  );
};

export default Address;
